<script setup lang="ts">
import { ref } from 'vue';
import { cloneDeep } from 'lodash';
import Checkbox from 'primevue/checkbox';
import HotelTargetStatus from './HotelTargetStatus.vue';

interface Props {
  hotel: object;
  isEdit: boolean;
  isPackageTab?: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  validateCheckbox: [{ type: string; hotelTargets: any }];
  validateSwitch: [event: any];
}>();

const hotelTargets = ref(cloneDeep(props.hotel));

const validateCheckbox = (type: string) => {
  emits('validateCheckbox', {
    type: type,
    hotelTargets: hotelTargets.value
  });
};

const validateSwitch = (event: any) => {
  emits('validateSwitch', event);
};
</script>
<template>
  <div class="hotel-target">
    <div class="mb-2 mt-4" v-if="!isEdit">{{ $t('management.hotel.create_hotel_in') }} <span class="text-primary">*</span></div>
    <div v-if="!isEdit" class="p-3 pb-0 border-dot-line">
      <div id="target-package-panel" class="field grid">
        <div class="col-4">
          <div class="flex gap-2 align-items-center">
            <Checkbox v-model="hotelTargets.isPackage" :binary="true" @update:modelValue="validateCheckbox('PACKAGE')" />
            <div>{{ $t('management.hotel.package_only') }}</div>
          </div>
        </div>
        <div class="col-8">
          <HotelTargetStatus :hotel="hotelTargets" :type="'PACKAGE_ONLY'" @validateSwitch="validateSwitch($event)" />
        </div>
      </div>
      <div id="target-hotel-panel" class="field grid">
        <div class="col-4">
          <div class="flex gap-2 align-items-center">
            <Checkbox v-model="hotelTargets.isHotel" :binary="true" @update:modelValue="validateCheckbox('HOTEL')" />
            <div>{{ $t('management.hotel.hotel_only') }}</div>
          </div>
        </div>
        <div class="col-8">
          <HotelTargetStatus :hotel="hotelTargets" :type="'HOTEL_ONLY'" @validateSwitch="validateSwitch($event)" />
        </div>
      </div>
    </div>
    <div v-else class="mt-4 p-2 border-dot-line">
      <div v-if="isPackageTab" id="target-package-panel" class="field grid">
        <div class="col-4 mt-3">
          <div class="flex gap-2 align-items-center">
            <Checkbox v-model="hotelTargets.isPackage" :binary="true" @update:modelValue="validateCheckbox('PACKAGE')" />
            <div>{{ $t('management.hotel.package_only') }}</div>
          </div>
        </div>
        <div class="col-8 mt-4">
          <HotelTargetStatus :hotel="hotelTargets" :type="'PACKAGE_ONLY'" @validateSwitch="validateSwitch($event)" />
        </div>
      </div>
      <div v-if="!isPackageTab" id="target-hotel-panel" class="field grid">
        <div class="col-4 mt-3">
          <div class="flex gap-2 align-items-center">
            <Checkbox v-model="hotelTargets.isHotel" :binary="true" @update:modelValue="validateCheckbox('HOTEL')" />
            <div>{{ $t('management.hotel.hotel_only') }}</div>
          </div>
        </div>
        <div class="col-8 mt-4">
          <HotelTargetStatus :hotel="hotelTargets" :type="'HOTEL_ONLY'" @validateSwitch="validateSwitch($event)" />
        </div>
      </div>
    </div>
  </div>
</template>
